import { cva } from "class-variance-authority";

export const buttonVariants = cva(
	"inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-default  font-semibold transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
	{
		variants: {
			variant: {
				default:
					"bg-primary-600 text-white hover:bg-primary-600/50  disabled:bg-primary-100 disabled:text-textDark",
				defaultLighter:
					"bg-primary-500 text-secondary hover:opacity-90  disabled:bg-primary-100 disabled:text-textDark",

				destructive: "bg-utility-red text-white hover:bg-utility-red/90",
				outline: " border-border border-[1px] px-2 py-[2px] text-textDark",
				secondary: "bg-secondary text-secondaryText",
				ghost: "hover:bg-accent hover:text-accent-foreground ",
				unstyled: "hover:bg-none block text-left",
				link: "text-textDark underline-offset-4 hover:underline",
				keypad:
					"active:bg-accent active:text-accent-foreground md:hover:bg-accent md:hover:text-accent-foreground active:scale-95 active:scale-95 transition-transform ease-in-out",
			},
			size: {
				default: "min-h-[3.625rem] px-4 py-4  text-base",
				sm: "h-8 px-3 text-sm",
				md: "h-9 px-4 text-sm",
				lg: "h-10 px-8 text-md",
				icon: "h-9 w-9",
				squareLarge: "h-14 w-14",
				compact: "p-0 min-h-auto [&_svg]:size-auto rounded-none",
			},
			weight: {
				normal: "font-normal",
				bold: "font-semibold",
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	},
);
